<template>
  <div class="klab-page">
    <header>
      <div class="normal-header-block">
        <div class="container">
          <div class="klab-slogan slogan-container">
            <img src="../assets/klab-logo.svg">
            <h1>在线数据分析与人工智能开发工具</h1>
          </div>
        </div>
      </div>
    </header>
    <section>
      <div class="bg-block bg-intro">
        <div class="intro-container container">
          <div class="intro-header block-header">
            <h2>关于 KesciLab</h2>
            <h3>About KesciLab</h3>
          </div>
          <div class="intro-content">
            <div class="intro-flex-wrapper">
              <div class="intro-info-card">
                <p>KesciLab（简称“K-Lab”）是中国首款数据分析及AI开发协同工具，在国际同类型工具中也具备领先水平。基于Jupyter Notebook自主研发的K-Lab，可满足数据科学家、人工智能工程师、商业分析师等数据工作者在线完成分类、建模、分析、可视化、结果输出等任务，并支持私有化部署和云端协同，帮助企业、高校、科研机构开展工业级数据科学应用与人工智能研发。</p>
                <p>目前，IBM、中国联通、平安科技、百度、携程、快手、拍拍贷、同盾科技、好未来等企业已在部分业务场景中使用了K-Lab进行数据价值的创造，清华大学、北京大学、中国人民大学、上海交通大学等知名院校也已采用基于K-Lab的数据科学及人工智能教学与实训平台。</p>
              </div>
              <div class="intro-info-card">
                <img src="../assets/kescilab-color.png"/>
              </div>
            </div>
            <div class="intro-flex-wrapper">
              <div class="intro-type-card">
                <h2>教育版</h2>
                <p>数据科学与人工智能<br/>高校教研平台</p>
              </div>
              <div class="intro-type-card">
                <h2>科研版</h2>
                <p>科研机构<br/>数据科学研发平台</p>
              </div>
              <div class="intro-type-card">
                <h2>企业版</h2>
                <p>企业数据分析及AI<br/>开发平台</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-block bg-mode">
        <div class="mode-container container">
          <div class="mode-header block-header">
            <h2>K-Lab打通企业与高校<br/>引领数据科学与人工智能领域发展的新模式</h2>
            <h3>K-Lab breaks the wall between enterprises and education institutions, leading a new future of data science</h3>
          </div>
          <div class="mode-content">
            <div class="mode-card-container">
              <div class="mode-card-border">
                <div class="mode-card">
                  <h3>高校</h3>
                  <p>K-Lab支持数据科学课程体系</p>
                  <ul class="mode-list-wrapper">
                    <li class="mode-list-item">
                      自然语言处理
                    </li>
                    <li class="mode-list-item">
                      医学图像分析
                    </li>
                    <li class="mode-list-item">
                      计算机视觉
                    </li>
                    <li class="mode-list-item">
                      交互式可视分析
                    </li>
                    <li class="mode-list-item">
                      语音识别技术
                    </li>
                    <li class="mode-list-item">
                      智能分布式计算
                    </li>
                    <li class="mode-list-item">
                      生物特征识别
                    </li>
                    <li class="mode-list-item">
                      语义计算
                    </li>
                    <li class="mode-list-item">
                      深度识别
                    </li>
                    <li class="mode-list-item">
                      计算神经科学
                    </li>
                    <li class="mode-list-item">
                      模式识别
                    </li>
                  </ul>
                  <div class="mode-case-card-border">
                    <div class="mode-case-card">
                      <div class="img-block">
                        <img src="https://cdn.kesci.com/client/logo/v2/qinghua_grey.png">
                      </div>
                      <h4>清华轻装上阵AI教学</h4>
                    </div>
                  </div>
                  <div class="mode-case-card-border">
                    <div class="mode-case-card">
                      <div class="img-block">
                        <img src="https://cdn.kesci.com/client/logo/v2/beida_grey.png">
                      </div>
                      <h4>北大人工智能学科共建</h4>
                    </div>
                  </div>
                  <div class="mode-case-card-border">
                    <div class="mode-case-card">
                      <div class="img-block">
                        <img src="https://cdn.kesci.com/client/logo/v2/松山湖.png">
                      </div>
                      <h4>人工智能的产业应用培训</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mode-card-border">
                <div class="mode-card">
                  <h3>企业</h3>
                  <p>K-Lab解决企业实际业务问题</p>
                  <ul class="mode-list-wrapper">
                    <li class="mode-list-item">
                      智能精准营销
                    </li>
                    <li class="mode-list-item">
                      自动驾驶
                    </li>
                    <li class="mode-list-item">
                      智能推荐
                    </li>
                    <li class="mode-list-item">
                      身份认证系统
                    </li>
                    <li class="mode-list-item">
                      金融风控
                    </li>
                    <li class="mode-list-item">
                      智能医疗
                    </li>
                    <li class="mode-list-item">
                      智能投稿
                    </li>
                    <li class="mode-list-item">
                      智能法律咨询
                    </li>
                    <li class="mode-list-item">
                      智能行研
                    </li>
                    <li class="mode-list-item">
                      视频监控及应用
                    </li>
                    <li class="mode-list-item">
                      语音助手
                    </li>
                  </ul>
                  <div class="mode-case-card-border">
                    <div class="mode-case-card">
                      <div class="img-block">
                        <img src="https://cdn.kesci.com/client/logo/v2/ctrip_grey.png">
                      </div>
                      <h4>酒店客户流失预测分析</h4>
                    </div>
                  </div>
                  <div class="mode-case-card-border">
                    <div class="mode-case-card">
                      <div class="img-block">
                        <img src="https://cdn.kesci.com/client/logo/v2/QIYI_grey.png">
                      </div>
                      <h4>综艺视频精彩片段识别</h4>
                    </div>
                  </div>
                  <div class="mode-case-card-border">
                    <div class="mode-case-card">
                      <div class="img-block">
                        <img src="https://cdn.kesci.com/client/logo/v2/qcds_grey.png">
                      </div>
                      <h4>智能客服算法模型</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-block bg-advantage">
        <div class="advantage-container container">
          <div class="advantage-header block-header">
            <h2>KesciLab 的四大技术优势</h2>
            <h3>Why KesciLab</h3>
          </div>
          <div class="advantage-content">
            <div class="advantage-flex-wrapper">
              <div class="advantage-menu">
                <ul class="advantage-list">
                  <li :class="{active: activeCard === 0}" @click="scrollToCard(0)"><span class="list-order">01</span>数据团队的协同管理工具</li>
                  <li :class="{active: activeCard === 1}" @click="scrollToCard(1)"><span class="list-order">02</span>功能丰富的专业化分析界面</li>
                  <li :class="{active: activeCard === 2}" @click="scrollToCard(2)"><span class="list-order">03</span>业界领先的资源调度能力</li>
                  <li :class="{active: activeCard === 3}" @click="scrollToCard(3)"><span class="list-order">04</span>开箱即用的云端分析环境</li>
                </ul>
                <img src="../assets/klab-advantage.png"/>
              </div>
              <div class="advantage-detail-container">
                <div class="advantage-card" data-index="0">
                  <div class="advantage-card-header">
                    <div class="advantage-card-header-mix">
                      <div class="card-order">01</div>
                      <h3>数据团队的协同管理工具</h3>
                    </div>
                    <img src="../assets/img-advantage1.svg">
                  </div>
                  <ul>
                    <li>
                      <h4>权限管理</h4>
                      <p>对数据、算力、项目进行细粒度的权限管理，保证企业内部的数据安全</p>
                    </li>
                    <li>
                      <h4>算法管理</h4>
                      <p>通过自动测评模块高效管理算法模型，实现对算法的生命周期管理</p>
                    </li>
                  </ul>
                </div>
                 <div class="advantage-card"  data-index="1">
                  <div class="advantage-card-header">
                    <div class="advantage-card-header-mix">
                      <div class="card-order">02</div>
                      <h3>功能丰富的专业化分析界面</h3>
                    </div>
                    <img src="../assets/img-advantage2.svg">
                  </div>
                  <ul>
                    <li>
                      <h4>弹性调度</h4>
                      <p>K-Lab通过自主研发的高可用调度器，弹性调度计算资源，保证资源的按量分配，高效提高资源利用率，保证资源调度的高稳定性和快速响应</p>
                    </li>
                    <li>
                      <h4>跨云架构</h4>
                      <p>K-Lab支持跨云调度国内外主流云计算厂商（如AWS、阿里云、百度云、腾讯云）的计算资源，从而能够支持面向多类型业务的混合资源调度方案</p>
                    </li>
                  </ul>
                </div>
                 <div class="advantage-card" data-index="2">
                  <div class="advantage-card-header">
                    <div class="advantage-card-header-mix">
                      <div class="card-order">03</div>
                      <h3>业界领先的资源调度能力</h3>
                    </div>
                    <img src="../assets/img-advantage3.svg">
                  </div>
                  <ul>
                    <li>
                      <h4>统一的开发环境</h4>
                      <p>K-Lab在容器中预安装所有主流数据科学的算法和框架，一方面可以开箱即用地使用自己已经熟悉的算法，同时能够实时与他人同步自己的分析成果</p>
                    </li>
                    <li>
                      <h4>文件储存</h4>
                      <p>提供实时存储的文件系统，云端保存数据分析的中间结果</p>
                    </li>
                  </ul>
                </div>
                 <div class="advantage-card" data-index="3">
                  <div class="advantage-card-header">
                    <div class="advantage-card-header-mix">
                      <div class="card-order">04</div>
                      <h3>开箱即用的云端分析环境</h3>
                    </div>
                    <img src="../assets/img-advantage4.svg">
                  </div>
                  <ul>
                    <li>
                      <h4>专业版Notebook</h4>
                      <p>K-Lab Notebook打通了数据源、分析过程、分析成果，提供高效工作流，并针对通信安全进行前后端优化</p>
                    </li>
                    <li>
                      <h4>数据服务</h4>
                      <p>高效挂载分析数据，提供智能预览，帮助完成数据初探工作</p>
                    </li>
                    <li>
                      <h4>代码片段</h4>
                      <p>提供代码片段功能，对分析师的算法进行精细化管理，提高代码的复用性</p>
                    </li>
                    <li>
                      <h4>多平台</h4>
                      <p>提供云端服务与PC端、移动端多平台操作界面，随时随地开展分析工作</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-block bg-function">
        <div class="function-container container">
          <div class="function-header block-header">
            <h2>K-Lab 是中国首款 Jupyter Notebook 数据分析平台<br/>实现“执行-探索-报告”的专属数据分析模式</h2>
            <h3>K-Lab is the first Data Science Platform with Jupyter application in China, embraces the unique 'Execute-Explore-Report' data analysis process</h3>
          </div>
          <div class="function-content">
            <div class="function-flex-wrapper">
              <img class="img-menu" src="../assets/klab-function.svg" >
              <img class="img-illustration" src="../assets/klab-illustration.svg" >
            </div>
          </div>
        </div>
      </div>
      <div class="bg-block bg-demand">
        <div class="demand-container container">
          <div class="demand-header block-header">
            <h2>K-Lab是具备国际领先性的云原生数据科学应用平台<br/>超强的资源调度能力满足不同级别的数据分析需求</h2>
            <h3>K-Lab is an internatioanlly leading cloud native data science platform, along with powerful elastic resource allocation mechanism</h3>
          </div>
          <div class="demand-content">
            <div class="demand-flex-wrapper">
              <img style="width:425px;height:auto;" src="../assets/img-demand.png">
              <div class="demand-list-container">
                <ul>
                  <li>
                    <h3>应用先进的云原生架构</h3>
                    <p>云原生是一种构建和运行应用程序的方法，利用了云计算按需计算的能力和即用即付定价模式的优势来帮助客户扩展任务K-Lab是以云计算平台的快速响应为基础而构建和部署的数据分析应用平台，为数据分析任务提供更高的灵活性、弹性和可移植性。</p>
                  </li>
                  <li>
                    <h3>高效的弹性调度服务</h3>
                    <p>K-Lab通过自主研发的高可用调度器进行物理机集群弹性伸缩，提供基于客户用量预测的按需分配资源调度服务。充分监控资源健康状态，可以保证客户发起分析任务时的资源调度的高稳定性和快速响应，高效利用计算资源</p>
                  </li>
                  <li>
                    <h3>强大的跨云调度能力</h3>
                    <p>为了保证客户的云计算资源供应，K-Lab支持跨云调度国内外主流云计算厂商（如AWS、阿里云、百度云、腾讯云）的计算资源，充分利用全行业的云计算能力。K-Lab是国内首家能够提供跨云服务的在线分析协作平台，从而能够支持面向多类型业务、大规模应用场景的混合资源调度方案。</p>
                  </li>
                </ul>
                <p class="demand-tip">K-Lab除了提供高效的公有云版本外，也提供基于私有云或混合云版本的高可用部署与对接，保障数据安全需求。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { smoothScrollTo } from '../utils/scroll.js';
import throttle from 'lodash.throttle';
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.bindScroll();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.unBindScroll();
    next();
  },
  data() {
    return {
      $scrollListener: null,
      activeCard: 0,
      lockListener: false
    };
  },
  methods: {
    scrollToCard(index) {
      this.activeCard = index;
      const el = this.$el.querySelector(`.advantage-card[data-index="${index}"]`);
      if (el) {
        this.lockListener = true;
        smoothScrollTo(el);
        window.setTimeout(() => {
          this.lockListener = false;
        }, 500);
      }
    },
    bindScroll() {
      if (this.$scrollListener) {
        return;
      }
      this.$scrollListener = throttle(() => {
        if (this.lockListener) {
          return;
        }
        const els = this.$el.querySelectorAll('.advantage-card');
        const gap = window.innerHeight * 0.5;
        let idx = 0;
        [].forEach.call(els, function(el) {
          const rect = el.getBoundingClientRect();
          if (rect.top < gap) {
            idx = parseInt(el.dataset.index, 10);
          }
        });
        this.activeCard = idx;
      }, 500);
      window.addEventListener('scroll', this.$scrollListener);
    },
    unBindScroll() {
      if (!this.$scrollListener) {
        return;
      }
      window.removeEventListener('scroll', this.$scrollListener);
      this.$scrollListener = null;
    }
  }
};
</script>
<style lang="scss">
.klab-page {
  .normal-header-block {
    background-image: url("../assets/banners/klab.jpg");
  }
  .bg-mode {
    height: 920px;
    background-image: url('../assets/bg-mode.png');
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: #092846;
    h2, h3 {
      color: #fff;
    }
  }
  .bg-function {
    height: 840px;
    background-image: url('../assets/bg-function.png');
    background-size: cover;
    background-position: center center;
    h2, h3 {
      color: #fff;
    }
  }
  .intro-flex-wrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 28px;
    //align-items: center;
    .intro-info-card {
      width: 48%;
      img {
        width: 100%;
        margin-top: 40px;
      }
      p {
        color: #002040;
        margin-bottom: 24px;
      }
    }
    .intro-type-card {
      height: 150px;
      padding: 12px 24px;
      border-radius: 6px;
      box-shadow: 0px 0px 23px 0px rgba(23, 128, 224, 0.12);
      text-align: center;
      width: 30%;
      h2 {
        font-size: 24px;
        color: #006EFF;
        margin-bottom: 18px;
      }
      p {
        color: #6E767F;
        line-height: 1.5;
      }
    }
  }
  .mode-card-container {
    display: flex;
    justify-content: space-between;
    .mode-card-border {
      background-image: linear-gradient(to right, #0066FF,#CC33FF);
      width: 370px;
      height: 600px;
      padding: 1px;
      border-radius: 4px;
    }
    .mode-card {
      color: #fff;
      text-align: center;
      width: 100%;
      height: 100%;
      // width: 370px;
      // height: 600px;
      padding: 24px 32px;
      background-color: #103961;
      // border: solid 1px;
      border-radius: 4px;
      // border-image: linear-gradient(to right, #0066FF,#CC33FF) 30 30;
      p {
        color: #fff;
      }
      h4 {
        font-size: 14px;
      }
      ul.mode-list-wrapper {
        display: flex;
        flex-wrap: wrap;
        padding: 0px;
        justify-content: space-between;
        list-style: inside url("../assets/list-style-circle.svg");
      }
      .mode-list-item {
        width: 40%;
        text-align: left;
        margin-bottom: 12px;
      }
      .mode-case-card-border {
        background-image: linear-gradient(to right, #0066FF,#CC33FF);
        border-radius: 4px;
        padding: 1px;
        margin: 8px 0px;
        width: 100%;
      }
      .mode-case-card {
        width: 100%;
        display: flex;
        align-content: center;
        padding: 20px 16px;
        border-radius: 4px;
        background-color: #103961;
        .img-block {
          width: 35%;
          display: flex;
          align-items: center;
          filter: invert(1);
          img {
            height: auto;
            width: auto;
            max-height: 24px;
            max-width: 100%;
            filter: brightness(0);
          }
        }
      }
    }
  }
  .advantage-flex-wrapper {
    display: flex;
    justify-content: space-between;
    .advantage-menu {
      height: 600px;
      margin-bottom: 64px;
      position: sticky;
      top: 100px;
      width: 30%;
      text-align: center;
      img {
        width: 60%;
      }
    }
    .advantage-list {
      list-style: none;
      padding-left: 80px;
      text-align: left;
      margin-bottom: 24px;
      li {
        cursor: pointer;
        font-size: 14px;
        color: #9B9B9B;
        margin-bottom: 12px;
        &.active {
          color: #006eff;
        }
      }
      .list-order {
        font-family: Avenir-BlackOblique;
        margin-right: 12px;
      }
    }
    .advantage-detail-container {
      padding-bottom: 96px;
    }
    .advantage-card {
      width: 720px;
      min-height: 600px;
      border-radius: 4px;
      box-shadow: 0px 0px 23px 0px rgba(23, 128, 224, 0.12);
      background-image: url('../assets/bg-advantage-card.svg');
      background-position: center bottom;
      background-repeat: no-repeat;
      padding: 32px 64px;
      margin-bottom: 64px;
    }
    .advantage-card-header {
      display: flex;
      justify-content: space-between;
      .card-order {
        font-size: 100px;
        color: #6E767F;
        font-family: Avenir-BlackOblique;
        opacity: 0.08;
      }
      h3 {
        position: relative;
        top: -60px;
        color: #002040;
        font-weight: 700;
      }
    }
    ul {
      list-style: url("../assets/list-style-circle.svg");
      margin-bottom: 28px;
      padding-left: 20px;
    }
    h4 {
      font-size: 14px;
      color: #002040;
    }
  }
  .function-flex-wrapper {
    display: flex;
    align-items: flex-start;
    .img-menu {
      width: 416px;
      margin-right: 24px;
    }
    // .function-menu {
    //   width: 35%;
    //   margin-right: 24px;
    //   .function-card {
    //     padding: 26px;
    //     margin: 17px 0px;
    //     background-image: url('../assets/bg-function-card.png');
    //     background-size: cover;
    //     opacity: 50%;
    //   }
    // }
  }
  .demand-flex-wrapper {
    display: flex;
    align-items: center;
    img {
      margin-right: 80px;
    }
    ul {
      list-style: url("../assets/list-style-circle.svg");
      margin-bottom: 28px;
    }
    .demand-tip {
      padding-left: 40px;
      color: #026EFF;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/klab.vue